import VehicleType from '../constants/VehicleType';
import { OutletId } from './Outlet';
import { Url } from './common';

export interface BrandId { __brandId: number}

export default class Brand {
  id!: BrandId;
  description = '';
  logo: Url | null = null;
  vehicleType: VehicleType | null = null;
  outletId: OutletId | null = null;
}